import axios from 'axios';

const state = () => ({
    labels: {},
})

const getters = {
}

const actions = {
    getCopy({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('/quotetoolapi/microcopy/get').then(response => {
                const { data } = response;

                commit('updateCopy', data);
                resolve();
            }).catch(error => {
                reject(error);
            })

        })
    }
}

const mutations = {
    updateCopy(state, labelsObj) {
        for (let label of labelsObj) {
            try {
                let property = label.itemKey.charAt(0).toLowerCase() + label.itemKey.slice(1);
                state.labels[property] = label.itemValue;
            } catch (e) {
                console.log("Error loading QuoteTool text label", label);
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
} 